import gql from 'graphql-tag'

export const insertImage = data => {
	return {
		mutation: gql`
			mutation insertSingleImage($image: images_insert_input!) {
				image: insert_images_one(object: $image) {
					id
				}
			}
		`,
		variables: {
			image: data
		}
	}
}
